import { Step2ValueModel, Step3ValueModel } from './types'
import {
    validateLegalName,
    validateChangeOwner,
    validateChangeOwnerDate,
    validateAccountType,
    validateBg,
    validatePg,
    validateStreetBox,
    validateZipCode,
    validateCity,
    validateMunicipality,
    validateVisitingAddressStreetAddress,
    validateVisitingAddressZipCode,
    validateVisitingAddressCity,
    validatePostalAddressStreetBox,
    validatePostalAddressZipCode,
    validatePostalAddressCity,
    validateVat,
} from '../shared/Validation'
import { AccountType } from '../shared/types'
import { FormErrorType } from "@sharedComponents/PantaForm/types";
import { validateRequired } from "@sharedComponents/PantaForm/utils";
import i18n from "@apps/Shared/translation/i18n";

export const validateRestaurantName = (
    restaurantName: string | undefined,
    currentErrors: FormErrorType[]
) => {
    const errors = validateRequired(
        restaurantName,
        'restaurantName',
        i18n.t('error.emptyRestaurantName'),
        currentErrors
    )

    return errors
}

export const validateStep2 = async (
    stepValues: Step2ValueModel,
    currentErrors: FormErrorType[]
) => {
    let errors = [...currentErrors]

    errors = validateChangeOwner(stepValues.changeOwner, errors)
    errors = validateChangeOwnerDate(
        stepValues.changeOwnerDate,
        stepValues.changeOwner === 'true',
        errors
    )
    errors = validateLegalName(stepValues.legalName, errors)
    if (stepValues.registeredForVAT === 'true') {
        errors = validateVat(stepValues.vatNumber, errors)
    }
    errors = validateAccountType(stepValues.accountType, true, errors)
    errors = validateBg(
        stepValues.bg,
        stepValues.accountType === AccountType.Bg,
        errors
    )
    errors = validatePg(
        stepValues.pg,
        stepValues.accountType === AccountType.Pg,
        errors
    )
    errors = validateStreetBox(stepValues.streetBox, errors)
    errors = validateZipCode(stepValues.zipCode, true, errors)
    errors = validateCity(stepValues.city, errors)

    return errors
}

export const validateStep3 = async (
    stepValues: Step3ValueModel,
    currentErrors: FormErrorType[]
) => {
    let errors = [...currentErrors]

    errors = validateRestaurantName(stepValues.restaurantName, errors)
    errors = validateMunicipality(stepValues.municipality, errors)
    errors = validateVisitingAddressStreetAddress(
        stepValues.visitingAddress.streetAddress,
        errors
    )
    errors = validateVisitingAddressZipCode(
        stepValues.visitingAddress.zipCode,
        true,
        errors
    )
    errors = validateVisitingAddressCity(
        stepValues.visitingAddress.city,
        errors
    )
    errors = validatePostalAddressStreetBox(
        stepValues.postalAddress.streetBox,
        stepValues.visitingAddress.isAlsoPostalAddress !== true,
        errors
    )
    errors = validatePostalAddressZipCode(
        stepValues.postalAddress.zipCode,
        stepValues.visitingAddress.isAlsoPostalAddress !== true,
        true,
        errors
    )
    errors = validatePostalAddressCity(
        stepValues.postalAddress.city,
        stepValues.visitingAddress.isAlsoPostalAddress !== true,
        errors
    )

    return errors
}